import { Option, Select, SelectWithAddItemOption } from '../../../../components/Input';
import React, { useEffect, useState } from 'react';
import { useFormDataContext } from '../../contexts/form-data.ctx';
import { Box } from '../../../../components/Box';
import { Checkbox, Form, Input } from 'antd';
import Text from 'antd/lib/typography/Text';
import { translations } from '../../../../utils/LocalizedStrings';


function SelectPayment({ documentId, name, label = 'Select', ...rest }) {


  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const values = useFormDataContext(({ data, setField }) => ({
    value: data[name] || { paymentType: "", paid: false },
    setField
  }));
  const [fieldValues, setFieldValues] = useState(values)
  var IBAN = require('iban');

  const handleChange = () => {
    if (fieldValues.value.iban) {
      fieldValues.value.iban = IBAN.printFormat(fieldValues.value.iban, " ")
    }
    values.setField({
      target: {
        name,
        value: fieldValues.value
      },
    });
  }

  const focus = () => {
    document.querySelectorAll('.mention[data-id="' + name + '"]').forEach((el) => {
      el.classList.add('mention--focus');
    });
  };

  const blur = () => {
    document.querySelectorAll('.mention[data-id="' + name + '"]').forEach((el) => {
      el.classList.remove('mention--focus');
    });
    handleChange();
  };

  const changeValue = (e) => {
    if (e.target.type === "checkbox") {
      fieldValues.value[e.target.name] = e.target.checked
      handleChange()
    } else {
      console.log(fieldValues.value)
      console.log(rest)
      fieldValues.value[e.target.name] = e.target.value
    }
    forceUpdate()
  }

  return (
    <form id={name} className="selectPayment nestedGrid">
      <span className="">
        <Box flex={1}>
          <Form.Item>
            <Select
              id={name + "_paymentType"}
              onFocus={focus}
              onBlur={blur}
              label={label}
              name="paymentType"
              onChange={(value) => changeValue({ target: { name: "paymentType", value } })}
              value={fieldValues.value.paymentType}>
              <Option value="">
                {translations.artifacts.SelectPaymentBox.choose}
              </Option>
              <Option value="cash">
                {translations.artifacts.SelectPaymentBox.cash}
              </Option>
              <Option value={"transfer"}>
                {translations.artifacts.SelectPaymentBox.transfer}
              </Option>
            </Select>
          </Form.Item>
        </Box>
      </span>
      {fieldValues.value.paymentType === "cash" &&
        <Checkbox
          style={{ display: 'flex', justifyContent: 'end' }}
          value={fieldValues.value.paid}
          name="paid"
          onChange={changeValue}
          className="orderFormCheckbox">
          {`${translations.artifacts.SelectPaymentBox.didRecieve1} ${rest.transfererName ? rest.transfererName.toLowerCase() : "prevodca"} ${translations.artifacts.SelectPaymentBox.didRecieve2}`}
        </Checkbox>
      }
      <span className="selectPaymentIban">
        {fieldValues.value.paymentType === "transfer" &&
          <Box flex={1}>
            <Form.Item validateStatus={IBAN.isValid(fieldValues.value.iban) ? '' : 'error'}>
              <Text strong style={!IBAN.isValid(fieldValues.value.iban) && { color: '#f00' }}>
                IBAN
              </Text>
              <Input
                id={name + "_iban"}
                onFocus={focus}
                onBlur={blur}
                name="iban"
                placeholder="IBAN"
                onChange={changeValue}
                value={fieldValues.value.iban ? fieldValues.value.iban : ""}
              />
            </Form.Item>
          </Box>
        }
      </span>
    </form>
  );
}

function SelectPaymentRenderer(values, id, artifact) {
  if (
    values &&
    values[id]
  ) {
    if (values[id].paymentType === "cash") {
      if (values[id].paid) {
        return `v hotovosti; ${artifact.transfererName ? artifact.transfererName : "Prevodca"} vyhlasuje a svojím podpisom tejto Zmluvy potvrdzuje, že dohodnuté finančné prostriedky riadne prevzal v celej výške pri podpise tejto Zmluvy.`
      } else {
        return "v hotovosti"
      }
    }
    if (values[id].paymentType === "transfer") {
      return "prevodom na účet, IBAN: " + (values[id].iban ? values[id].iban : "")
    }
  }
  return artifact.name
}


function PaymentValidator(values, id) {
  let IBAN = require('iban');
  if (!values[id]) {
    return false
  }
  if (!values[id].paymentType) {
    return false
  }
  if (values[id].paymentType === "transfer") {
    if (!values[id].iban || !IBAN.isValid(values[id].iban)) {
      return false
    }
  }
  return true
}

function RetributionFieldsValidator(values, id) {
  let invalidFields = []
  let IBAN = require('iban');
  if (!values[id]) {
    invalidFields.push(id + "_paymentType")
  }
  if (!values[id]?.paymentType) {
    invalidFields.push(id + "_paymentType")
  }
  if (values[id]?.paymentType === "transfer") {
    if (!values[id].iban || !IBAN.isValid(values[id].iban)) {
      invalidFields.push(id + "_iban")
    }
  }
  return invalidFields
}


export default {
  Mutator: SelectPayment,
  HTMLRenderer: SelectPaymentRenderer,
  Validator: PaymentValidator,
  FieldsValidator: RetributionFieldsValidator
};
